export const SRBigCalendarEventMonthWrapper = (props) => {
  const { components } = props

  const Event = components.event

  return <Event {...props} />
}
